import { render, staticRenderFns } from "./FormArea.vue?vue&type=template&id=32f0966e"
import script from "./FormArea.vue?vue&type=script&lang=js"
export * from "./FormArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports